export enum FillinOriginType {
    app = 'app',
    admin = 'admin',
}